'use es6';

import * as client from 'DesignData/api/CosIndexConnections';
import { COS_INDEX_CONNECTIONS_FETCH_PARENTS, COS_INDEX_CONNECTIONS_BULK_FETCH_PARENTS } from 'DesignData/actions/ActionTypes';
/**
 * Fetch parent connections for asset by ID.
 * @param  {Number} assetId ID of asset to fetch connections for.
 */

export function fetchForParentConnections(assetId, extraParams = {}) {
  const {
    request,
    receive,
    error
  } = fetchForParentConnections;
  return dispatch => {
    dispatch(request(assetId));
    return client.fetchParents(assetId, extraParams).then(result => {
      dispatch(receive(result, assetId));
    }).catch(err => {
      dispatch(error(err, assetId));
    });
  };
}

fetchForParentConnections.request = function request(assetId) {
  return {
    type: COS_INDEX_CONNECTIONS_FETCH_PARENTS,
    assetId
  };
};

fetchForParentConnections.receive = function receive(parents, assetId) {
  return {
    type: COS_INDEX_CONNECTIONS_FETCH_PARENTS,
    assetId,
    parents
  };
};

fetchForParentConnections.error = function error(err, assetId) {
  return {
    type: COS_INDEX_CONNECTIONS_FETCH_PARENTS,
    assetId,
    error: err
  };
};
/**
 * Bulk fetch oarent connections.
 * @param  {Array.<Number>} assetIds IDs of assets to fetch parents for.
 */


export function bulkFetchParentConnections(assetIds) {
  const {
    request,
    receive,
    error
  } = bulkFetchParentConnections;
  return dispatch => {
    dispatch(request(assetIds));
    return client.bulkFetchParents(assetIds).then(result => {
      dispatch(receive(result, assetIds));
    }).catch(err => {
      dispatch(error(err, assetIds));
    });
  };
}

bulkFetchParentConnections.request = function request(assetIds) {
  return {
    type: COS_INDEX_CONNECTIONS_BULK_FETCH_PARENTS,
    assetIds
  };
};

bulkFetchParentConnections.receive = function receive(parents, assetIds) {
  return {
    type: COS_INDEX_CONNECTIONS_BULK_FETCH_PARENTS,
    assetIds,
    parents
  };
};

bulkFetchParentConnections.error = function err(error, assetIds) {
  return {
    type: COS_INDEX_CONNECTIONS_BULK_FETCH_PARENTS,
    assetIds,
    error
  };
};